var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThingMgt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "thingMgt_svg__a_".concat(unique),
    d: "M0 20.002h20V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6 13.25a.6.6 0 01.6.6v3.151h3.15a.6.6 0 010 1.2H2.6a.6.6 0 01-.6-.6v-3.75a.6.6 0 01.6-.6zm15 0a.6.6 0 01.6.6v3.751a.6.6 0 01-.6.6h-3.75a.6.6 0 110-1.2H17v-3.15a.6.6 0 01.6-.6zm-7.305-8.972l.096.046 4.565 2.634c.093.054.168.13.22.22.015.027.013.063.024.092.017.044.036.088.047.135l.01.072v.003l-.016 5.244a.598.598 0 01-.223.466l-.075.051-4.535 2.635c-.002 0-.002.002-.003.002a.597.597 0 01-.502.043l-.097-.044-4.563-2.635a.6.6 0 01-.293-.43l-.007-.092.015-5.244c0-.052.026-.097.04-.146.012-.051.013-.106.04-.152.026-.045.072-.072.11-.11.023-.024.043-.052.068-.077l.04-.032.002-.001v-.001h.001L9.79 4.325a.594.594 0 01.505-.047zm-4.14 4.237l-.012 3.861L9.51 14.32l.01-3.379.001-.483-3.366-1.943zm7.898.007l-.215.125-3.119 1.811-.006 2.57-.004 1.285 3.334-1.937.01-3.854zm-3.96-2.986l-3.338 1.94 3.365 1.943.66-.383 2.68-1.556-3.368-1.944zM6.35 2a.6.6 0 01.097 1.191L6.35 3.2H3.2v3.15a.6.6 0 01-1.193.098L2 6.349V2.6a.6.6 0 01.502-.591L2.6 2h3.75zM17.6 2a.6.6 0 01.6.6v3.75a.6.6 0 01-1.2 0V3.2h-3.15a.6.6 0 110-1.2z",
    id: "thingMgt_svg__b_".concat(unique)
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "thingMgt_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#thingMgt_svg__b_".concat(unique)
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#thingMgt_svg__b_".concat(unique)
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    mask: "url(#thingMgt_svg__c)",
    d: "M0 0h20v20.002H0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThingMgt);
export default __webpack_public_path__ + "static/assets/thingMgt.c312392a.svg";
export { ForwardRef as ReactComponent };